import { useNavigate } from "react-router-dom";
import "./StaffAttendanceTable.css";

export default function StaffAttendanceTable({ data = [] }) {
    const navigate = useNavigate();

    const getDay = (user) => user.dates?.[0];

    const formatDate = (date) =>
        date ? new Date(date).toLocaleDateString() : "-";

    const formatTime = (date) =>
        date
            ? new Date(date).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
            })
            : "-";

    const getBadgeClass = (name) => {
        switch (name.toLowerCase()) {
            case "came on time":
                return "green";
            case "late":
                return "orange";
            case "left early":
                return "red";
            case "left on time":
                return "blue";
            case "absent":
                return "dark";
            default:
                return "gray";
        }
    };

    return (
        <div className="staff-table-wrapper">
            <table className="staff-table">
                <thead>
                <tr>
                    <th>Name</th>
                    <th>Date</th>
                    <th>Entry</th>
                    <th>Leave</th>
                    <th>Status</th>
                </tr>
                </thead>

                <tbody>
                {data.length === 0 ? (
                    <tr>
                        <td colSpan="5" className="empty">
                            No data
                        </td>
                    </tr>
                ) : (
                    data.map((user) => {
                        const day = getDay(user);

                        return (
                            <tr
                                key={user.id}
                                onClick={() =>
                                    navigate(`/user/${user.id}`)
                                }
                            >
                                <td>{user.name}</td>
                                <td>{formatDate(day?.date)}</td>
                                <td>{formatTime(day?.entry_time)}</td>
                                <td>{formatTime(day?.leave_time)}</td>
                                <td>
                                    <div className="status-wrapper">
                                        {day?.status?.length > 0 ? (
                                            day.status.map((s) => (
                                                <span
                                                    key={s.id}
                                                    className={`status-badge ${getBadgeClass(
                                                        s.name
                                                    )}`}
                                                >
                                                        {s.name}
                                                    </span>
                                            ))
                                        ) : (
                                            <span className="status-badge dark">
                                                    Absent
                                                </span>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        );
                    })
                )}
                </tbody>
            </table>
        </div>
    );
}
